import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';

import ReportCardsDetailsDialog from '../parts/ReportCards/ReportCardsDetailsDialog';
import ReportCardsGroupTable from '../parts/ReportCards/ReportCardsGroupTable';
import ReportCardsGroupTiles from '../parts/ReportCards/ReportCardsGroupTiles';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class ReportCardsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      isDialogOpen: false,
      selectedReportCard: null,
    };

    this.axiosCancel = null;

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onDetailsButtonClick = this.onDetailsButtonClick.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
      selectedReportCard: null,
    });
  }

  onDetailsButtonClick(entry) {
    this.setState({
      isDialogOpen: true,
      selectedReportCard: entry,
    });
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    return axios
      .post(
        `${window.apiUrl}/getpupilreportcards`,
        qs.stringify({
          pupil_id: selectedPupil.id,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      isLoaded,
      isLoading,
      data,
      isDialogOpen,
      selectedReportCard,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="report-cards-page">
        <Typography
          className={classes.sectionHeading}
          variant="h5"
          component="h5"
        >
          {t('On-Report Cards')}
        </Typography>
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {isLoaded && data.length === 0 && (
          <p>{t('There are currently no On-Report Cards to display')}</p>
        )}
        {isLoaded && data.length > 0 && (
          <div>
            {isMobileApp && (
              <ReportCardsGroupTiles
                entries={data}
                onEntryClick={this.onDetailsButtonClick}
              />
            )}
            {!isMobileApp && (
              <ReportCardsGroupTable
                entries={data}
                onEntryClick={this.onDetailsButtonClick}
              />
            )}
          </div>
        )}
        <ReportCardsDetailsDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={this.onDialogClose}
          reportCard={selectedReportCard}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(ReportCardsPage))
);
